<template>
  <v-layout row wrap align-start fill-height pb-5>
    <v-flex xs12>
      <v-layout row wrap align-center mt-2 mb-2 :pr-3="$vuetify.breakpoint.smAndDown">
        <v-flex xs12 :pr-3="$vuetify.breakpoint.mdAndUp">
          <v-card class="pa-2">
            <h2>{{ $lang.header.besuche }}</h2>
            <div class="d-inline-flex">
              <v-layout row align-center>
                <span class="mr-2">{{$lang.labels.from}}</span>
                <v-menu
                    ref="menuFrom"
                    :close-on-content-click="false"
                    v-model="menuFrom"
                    :return-value.sync="fromDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                  <v-btn slot="activator" flat outline color="primary" class="ml-0 mr-auto">{{
                      formatDate(fromDate)
                    }}
                  </v-btn>
                  <v-btn slot="activator" fab flat dark small color="primary" class="mr-0">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <v-date-picker v-model="fromDate" @input="$refs.menuFrom.save(fromDate)" no-title scrollable
                                 color="primary"/>
                </v-menu>
              </v-layout>
              <v-layout row align-center>
                <span class="mx-2">{{$lang.labels.to}}</span>
                <v-menu
                    ref="menuTill"
                    :close-on-content-click="false"
                    v-model="menuTill"
                    :return-value.sync="toDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                  <v-btn slot="activator" flat outline color="primary" class="ml-0 mr-auto">{{
                      formatDate(toDate)
                    }}
                  </v-btn>
                  <v-btn slot="activator" fab flat dark small color="primary" class="mr-0">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <v-date-picker v-model="toDate" @input="$refs.menuTill.save(toDate)" no-title scrollable
                                 color="primary"/>
                </v-menu>
              </v-layout>
              <v-btn
                  :disabled="loading"
                  color="primary"
                  class="mx-0"
                  @click="search()">
                {{ $lang.labels.search }}
              </v-btn>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 pt-2 fill-height v-if="!visits || visits.length === 0" :pr-3="$vuetify.breakpoint.smAndDown">
      <v-layout fow wrap>
        <v-flex xs12 v-if="loading">
          <br>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-flex>
        <v-flex xs12 v-if="err">
          <v-alert
              color="error"
              class="err"
              icon="warning"
              value="true"
              v-if="err">{{ err }}
          </v-alert>
        </v-flex>
        <v-flex xs12 v-if="visits && visits.length === 0 && searchType === 'visits'">
          <v-alert
              color="error"
              class="err"
              icon="warning"
              value="true">No visits found.
          </v-alert>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 pt-2 fill-height v-if="visits && visits.length > 0" :pr-2="$vuetify.breakpoint.smAndDown">
      <v-layout fow wrap>
        <template v-for="(visit, index) in visits">
          <v-flex xs12 sm6 md4 pt-2 v-if="visits && visits.length > 0">
            <v-card :class="{
          'mb-2': true,
          'mr-3': $vuetify.breakpoint.mdAndUp,
          'mr-2': $vuetify.breakpoint.smAndDown,
          'pa-4': true
        }" :key="visit.id">
              <v-layout fow wrap>
                <v-flex xs12 v-if="visits && visits.length > 0">
                  <v-layout row wrap>
                    <v-flex xs6 pa-2>
                      <v-text-field
                          readonly
                          :label="$lang.labels.created"
                          hide-details
                          :placeholder="formatDateTime(visit.createdOn)"
                      />
                    </v-flex>
                    <v-flex xs6 pa-2>
                      <v-text-field
                          v-model="visit.table"
                          :label="$lang.labels.table"
                          hide-details
                      />
                    </v-flex>
                    <v-flex xs6 pa-2>
                      <v-text-field
                          v-model="visit.firstName"
                          :label="$lang.labels.firstName"
                          hide-details
                      />
                    </v-flex>
                    <v-flex xs6 pa-2>
                      <v-text-field
                          v-model="visit.lastName"
                          :label="$lang.labels.lastName"
                          hide-details
                      />
                    </v-flex>
                    <v-flex xs6 pa-2>
                      <v-text-field
                          v-model="visit.email"
                          :label="$lang.labels.email"
                          hide-details
                      />
                    </v-flex>
                    <v-flex xs6 pa-2>
                      <v-text-field
                          v-model="visit.phone"
                          :label="$lang.labels.phone"
                          hide-details
                      />
                    </v-flex>
                    <v-flex xs12 pt-2 pl-1>
                      <v-checkbox v-model="visit.delete" :label="$lang.labels.delete"/>
                    </v-flex>
                    <v-flex xs12 class="text-xs-right" pr-1>
                      <v-btn
                          :loading="visit.isLoading"
                          color="info"
                          class="mx-0"
                          @click="saveVisit(visit)">
                        {{ $lang.labels.save }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </template>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
// import auth from '../auth';

export default {
  name: 'AdminPanel',
  data() {
    return {
      searchType: 'visits',
      err: '',
      loading: false,
      fromDate: moment()
        .subtract(14, 'd')
        .startOf('d')
        .toISOString(),
      menuFrom: false,
      toDate: moment()
        .endOf('d')
        .toISOString(),
      menuTill: false,
      visits: null,
      loginProcessStarted: false,
      email: '',
      password: '',
      passwordRules: [
        v => !!v || this.$lang.errors.requiredPassword,
        v => (v && v.length >= 6 && v.length <= 35) || this.$lang.errors.passwordConditions,
      ],
      emailRules: [
        v => !!v || this.$lang.errors.requiredEmail,
        // eslint-disable-next-line
        v => (v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase())) || this.$lang.errors.notValidEmail,
      ],
    };
  },
  computed: {
    ...mapGetters({
      company: 'company',
      companyActive: 'companyActive',
    }),
  },
  methods: {
    formatDate(date) {
      return date ? moment(date)
        .format('YYYY-MM-DD') : this.$lang.actions.selectDate;
    },
    formatDateTime(date) {
      return moment(date)
        .format('DD/MM/YYYY HH:mm');
    },
    saveVisit(visit) {
      // eslint-disable-next-line no-param-reassign
      visit.isLoading = true;
      this.$webHelper.post(`visit/update/${visit.id}`, visit)
        .then((res) => {
          if (res.body && res.status === 200) {
            // eslint-disable-next-line no-param-reassign
            visit.isLoading = false;
          } else {
            this.err = res.body.statusText;
            setTimeout(() => {
              this.err = '';
            }, 6000);
            // eslint-disable-next-line no-param-reassign
            visit.isLoading = false;
          }
        })
        .catch((err) => {
          this.err = err;
          setTimeout(() => {
            this.err = '';
          }, 6000);
          // eslint-disable-next-line no-param-reassign
          visit.isLoading = false;
        });
    },
    search() {
      this.err = '';
      this.ordersResult = [];
      this.searchType = 'visits';
      if (!this.fromDate || !this.toDate) {
        this.err = 'Please select both dates';
        setTimeout(() => {
          this.err = '';
        }, 6000);
        return;
      }
      this.visits = null;
      this.loading = true;
      this.$webHelper.post('visit/search', {
        fromDate: this.fromDate,
        toDate: this.toDate,
      })
        .then((res) => {
          if (res.body && res.status === 200) {
            this.visits = res.body.visits.map((current) => {
              const visit = current;
              visit.isLoading = false;
              return visit;
            });
            this.loading = false;
          } else {
            this.err = res.body.statusText;
            setTimeout(() => {
              this.err = '';
            }, 6000);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.err = err;
          setTimeout(() => {
            this.err = '';
          }, 6000);
          this.loading = false;
        });
    },
  },
  created() {
    this.search();
  },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/VisitsSearch.vue